import './App.scss'
import './index.css'
import useQueryClient from 'hooks/useQueryClient'
import useAuthInitialization from 'hooks/useAuthInitialization'
// rotes
import Routes from 'routes/routes'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import CachePersister from 'components/atoms/cache-persister/cache-persister'
import { BrowserRouter as Router } from 'react-router-dom'

const App = () => {
	const queryClient = useQueryClient()

	// Inicialización única de autenticación
	useAuthInitialization()

	const RouterComp: any = Router

	return (
		<QueryClientProvider client={queryClient}>
			<CachePersister>
				<RouterComp>
					<Routes />
				</RouterComp>
			</CachePersister>
			{/* DevTools solo se muestran en desarrollo */}
			{process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
		</QueryClientProvider>
	)
}

export default App
